export const newSalesCardInformationConfig = {
  lightConfig: {
    description: 'primary1',
    title: 'neutral2',
  },
  darkConfig: {
    description: 'neutral6',
    title: 'neutral6',
  },
};
